import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
// import higoLogoFull from '@higo/ui/src/assets/icon/full-logo.svg';
import { LogoIcon, media } from '@higo/ui';

const LogoLink = styled(Link)(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    margin-right: 1rem;
    color: ${theme.palette.primary['500']};
    ${theme.media.desktop.min} {
      margin-right: 1.5rem;
    }
    ${media.mobile.max} {
      margin-right: 0.5rem;
    }
  `,
);

const StyledLogoIcon = styled(LogoIcon)(
  () => css`
    ${media.mobile.max} {
      width: 2rem;
    }
  `,
);

export const HeaderLogo = () => {
  return (
    <LogoLink id="higo-logo" to="/visits">
      <StyledLogoIcon size={38} />
    </LogoLink>
  );
};
